import auditTheme from './audit/theme';
import broadcastTheme from './broadcast/theme';

import {isAudit} from "../../helpers/relay";

export default isAudit() ? auditTheme : broadcastTheme;
